function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import DatePicker from "react-datepicker";
import { GoChevronDown } from "react-icons/go";
import { HiUserGroup } from "react-icons/hi";
import { FilterContext, UserContext, TrackingContext } from "..";
import "../css/react-datepicker.css";
import SearchBar from "../SearchBar";
import moment from "moment-timezone";
import { MenuFooter } from "./SideMenu";
import { AddEmployees, RenewalPaymentPending } from "./../Employees/EmployeesModal";
import { ApplyLeaveModal } from "./../ViewLeave/ViewLeave";
import { findIsWorkfolioSite } from "../utils";
import { MdPersonAdd, MdDateRange } from "react-icons/md";
import { FaCalendarPlus } from "react-icons/fa";
import { Card, Container, Row, Col } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
//import { FilterContext, UserContext } from "../index";

var filterOptions = ["Today", "This Week", "Yesterday", "This Month", "Last 7 Days", "Last Month", "Last Week", "Custom"];
var Header = function Header(props) {
  var activeMenus = props.activeMenus,
    organisationTeams = props.organisationTeams,
    linkAttribute = props.linkAttribute,
    linkComponent = props.linkComponent,
    organisationDetails = props.organisationDetails,
    setSearch = props.setSearch,
    search = props.search,
    from = props.from,
    viewMode = props.viewMode,
    setViewMode = props.setViewMode,
    handleFullScreen = props.handleFullScreen,
    history = props.history,
    rolesDetails = props.rolesDetails,
    organisationTeamData = props.organisationTeamData,
    getRoleData = props.getRoleData;
  var _useContext = useContext(FilterContext),
    startDate = _useContext.startDate,
    endDate = _useContext.endDate,
    organisationId = _useContext.organisationId,
    setDatesFilter = _useContext.setDatesFilter,
    teamId = _useContext.teamId,
    setTeamId = _useContext.setTeamId,
    setTeamName = _useContext.setTeamName,
    organisationUserCount = _useContext.organisationUserCount,
    isMobileView = _useContext.isMobileView,
    organisationBilling = _useContext.organisationBilling,
    organisationSettings = _useContext.organisationSettings,
    role = _useContext.role,
    timezoneFilter = _useContext.timezoneFilter,
    setTimezoneFilter = _useContext.setTimezoneFilter;
  var _useContext2 = useContext(UserContext),
    user = _useContext2.user;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    employeeDetails = _useState2[0],
    setEmployeeDetails = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    inviteType = _useState4[0],
    setInviteType = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    applyLeaveShow = _useState6[0],
    setApplyLeaveShow = _useState6[1];
  var _React$useState = React.useState(stringToArrayOutput("Free Plan Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    last14Days = _React$useState2[0],
    setLast14Days = _React$useState2[1];
  var handleClose = function handleClose() {
    setEmployeeDetails(null);
    setInviteType(null);
  };
  var handleShow = function handleShow(employee) {
    setEmployeeDetails(employee);
  };
  var handleRenewalPaymentPendingClose = function handleRenewalPaymentPendingClose() {
    setRenewalPaymentPendingShow(false);
  };
  var handleRenewalPaymentPendingShow = function handleRenewalPaymentPendingShow() {
    setRenewalPaymentPendingShow(true);
  };
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    renewalPaymentPendingShow = _useState8[0],
    setRenewalPaymentPendingShow = _useState8[1];
  var handleApplyLeaveShow = function handleApplyLeaveShow() {
    return setApplyLeaveShow(true);
  };
  var handleApplyLeaveClose = function handleApplyLeaveClose() {
    return setApplyLeaveShow(false);
  };
  var currentYear = moment().format("YYYY");
  var tracking = React.useContext(TrackingContext);
  var _ref = tracking || {},
    task = _ref.task,
    onStop = _ref.onStop,
    onStart = _ref.onStart;
  var value = React.useMemo(function () {
    return teamId === "all" && from === "web" ? {
      teamId: "all",
      teamName: "All Team"
    } : organisationTeams.find(function (t) {
      return t.teamId === teamId;
    });
  }, [teamId, organisationTeams]);
  var _useState9 = useState(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _useState10 = _slicedToArray(_useState9, 2),
    filterData = _useState10[0],
    setFilterData = _useState10[1];
  var onFilterChange = function onFilterChange(dates) {
    setDatesFilter(dates);
    setTimezoneFilter(localStorage.getItem("timezone"));
  };
  useEffect(function () {
    setFilterData(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  }, [startDate, endDate]);
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  var showDateFilter = from === "desktop" ? activeMenus.firstMenu !== "overview" : activeMenus.firstMenu !== "scheduled-reports" && activeMenus.firstMenu !== "settings" &&
  // activeMenus.firstMenu !== "my-projects" &&
  activeMenus.firstMenu !== "billing" && activeMenus.firstMenu !== "review-usage" && activeMenus.firstMenu !== "work-history" && activeMenus.firstMenu !== "reports" && activeMenus.firstMenu !== "project-details" && activeMenus.firstMenu !== "my-projects" && activeMenus.firstMenu !== "review-manual-time" && activeMenus.firstMenu !== "manual-time" && activeMenus.firstMenu !== "my-tasks" && activeMenus.firstMenu !== "task-overview" && activeMenus.firstMenu !== "apply-leave" && activeMenus.firstMenu !== "leave-summary" && activeMenus.firstMenu !== "manage-leave" && activeMenus.firstMenu !== "manage-holiday" && activeMenus.firstMenu !== "view-holiday" && activeMenus.firstMenu !== "edit-timesheet" && activeMenus.firstMenu !== "payroll-calculator" && activeMenus.firstMenu !== "real-time-alert";
  // &&
  // activeMenus.firstMenu !== "screenshots";

  // let showDateFilter1 = activeMenus.firstMenu == "screenshots" && role == "Member";
  // let showDateFilter1 = null;

  var showSearchBar = activeMenus.firstMenu === "my-teams" || activeMenus.firstMenu === "my-projects" || activeMenus.firstMenu === "review-offscreen-task" || activeMenus.firstMenu === "scheduled-reports" || activeMenus.secondMenu === "manage-teams" || activeMenus.secondMenu === "manage-employees" || activeMenus.firstMenu === "timesheet";
  var showTeamFilter = activeMenus.firstMenu !== "scheduled-reports" && activeMenus.secondMenu !== "manage-teams" && activeMenus.secondMenu !== "current-plan" && activeMenus.firstMenu !== "billing" && activeMenus.secondMenu !== "custom-report" && activeMenus.firstMenu !== "my-projects" && activeMenus.secondMenu !== "apps-usage" && activeMenus.firstMenu !== "task-overview" && activeMenus.secondMenu !== "track-settings" && activeMenus.firstMenu !== "apply-leave" && activeMenus.firstMenu !== "leave-summary" && activeMenus.firstMenu !== "manage-leave" && activeMenus.firstMenu !== "manage-holiday" && activeMenus.firstMenu !== "edit-timesheet" && activeMenus.firstMenu !== "project-details" && activeMenus.firstMenu !== "payroll-calculator" && activeMenus.secondMenu !== "manage-employees" && activeMenus.firstMenu !== "real-time-alert";
  var showReleaseNotes = activeMenus.firstMenu !== "settings";
  var showApplyLeaveBar = activeMenus.firstMenu === "apply-leave";

  //  &&
  // activeMenus.firstMenu !== "review-usage";

  // const onTeamChange = async (value) => {
  //   if (task?.activityType === "start" || task?.activityType === "break") {
  //     await onStop("stop");
  //     await setTeamId(value);
  //     await onStart?.({
  //       teamId: value,
  //       organisationId,
  //       userId: user.userId,
  //       updatedAt: new Date(),
  //       workedSecs: task?.workedSecs || 0,
  //       taskTimer: task?.workedSecs || 0,
  //     });
  //     await setTeamId(value);
  //   }
  //   else{
  //     await setTeamId(value);
  //   }
  // };

  React.useEffect(function () {
    if (from === "web" && showReleaseNotes) {
      var script = document.createElement("script");
      script.async = true;
      script.src = "https://cdn.headwayapp.co/widget.js";
      document.head.appendChild(script);
      var HW_config = {
        selector: ".workfolio-release-notes",
        // CSS selector where to inject the badge
        account: "7zeDKx",
        trigger: ".workfolio-release-notes-label"
      };
      script.onload = function () {
        window.Headway.init(HW_config);
      };
    }
  }, [showReleaseNotes]);
  React.useEffect(function () {
    if (filterData === "Today") {
      if (dateToYMD(startDate) !== dateToYMD(new Date())) {
        setDatesFilter({
          startDate: new Date(),
          endDate: null
        });
      }
    }
  }, [activeMenus]);
  var siteName = findIsWorkfolioSite(); // Workfolio or Rebrand domain name

  return /*#__PURE__*/React.createElement("div", {
    className: classNames("sidemenu-header-comman-div", {
      "sidemenu-header-fixes": isMobileView && from === "web"
    })
  }, from === "web" && !isMobileView && siteName == "workfolio" && (role == "Admin" || role == "Head") && showReleaseNotes ? /*#__PURE__*/React.createElement("div", {
    className: "workfolio-release-notes"
  }, /*#__PURE__*/React.createElement("span", {
    className: "workfolio-release-notes-label"
  }, "Release Notes")) : null, (from === "web" && organisationBilling.userCount === 0 || Number(organisationUserCount) < organisationBilling.userCount) && siteName == "workfolio" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) != "stopped" && (role == "Admin" || role == "Head") ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "rounded-pill px-3 page-content-wrapper-menu-add-user",
    size: "sm",
    onClick: function onClick() {
      if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.stoppedReason) == "failed") {
        handleRenewalPaymentPendingShow();
      } else {
        getRoleData();
        handleShow({});
      }
    }
  }, /*#__PURE__*/React.createElement(MdPersonAdd, {
    className: "page-content-wrapper-menu-add-user-icon"
  }), isMobileView && from === "web" ? "USER" : "ADD USERS"), /*#__PURE__*/React.createElement(AddEmployees, {
    roles: rolesDetails,
    teams: organisationTeamData === null || organisationTeamData === void 0 ? void 0 : organisationTeamData.organisationTeams,
    show: employeeDetails,
    handleClose: handleClose,
    teamId: teamId,
    inviteType: inviteType,
    setInviteType: setInviteType,
    organisationId: organisationId,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    teamsData: organisationTeamData,
    urlPath: "",
    organisationBilling: organisationBilling,
    employeeCount: organisationUserCount,
    role: role
  }), /*#__PURE__*/React.createElement(RenewalPaymentPending, {
    show: renewalPaymentPendingShow,
    handleClose: handleRenewalPaymentPendingClose
  }), /*#__PURE__*/React.createElement(ApplyLeaveModal, {
    applyLeaveShow: applyLeaveShow,
    handleApplyLeaveClose: handleApplyLeaveClose,
    organisationId: organisationId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    type: "add",
    userId: user.userId,
    activeTab: "upcoming"
    //holidayListData={holidayListData}
    ,
    role: role,
    workingDays: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.workingDays,
    currentYear: currentYear,
    organisationBilling: organisationBilling,
    last14Days: last14Days,
    setApplyLeaveShow: setApplyLeaveShow
  })) : (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" && (role == "Admin" || role == "Head") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Your plan has expired, pls renew the plan before adding new users.")
  }, /*#__PURE__*/React.createElement("div", {
    variant: "primary",
    className: "rounded-pill px-3 page-content-wrapper-menu-add-user add-user-disabled-div",
    size: "sm"
  }, /*#__PURE__*/React.createElement(MdPersonAdd, {
    className: "page-content-wrapper-menu-add-user-icon"
  }), isMobileView && from === "web" ? "USER" : "ADD USERS")) : role != "Admin" ? /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "rounded-pill px-3 page-content-wrapper-menu-add-user",
    size: "sm",
    onClick: function onClick() {
      window.open("https://www.getworkfolio.com/downloads", "_blank");
    }
  }, /*#__PURE__*/React.createElement(FiDownload, {
    className: "page-content-wrapper-menu-add-user-icon"
  }), "Download Desktop App Here") : null, from === "web" && showSearchBar && !isMobileView && (role == "Admin" || role == "Head") ? /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-search-bar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: search,
    onChange: setSearch,
    placeholder: "".concat(activeMenus.secondMenu === "manage-employees" ? "Search by name, email" : activeMenus.secondMenu === "settings" ? "Search in ".concat(activeMenus.secondMenu.replace(/-/g, " ")) : activeMenus.firstMenu === "review-offscreen-task" ? "Search in offscreen task" : "Search in ".concat(activeMenus.firstMenu.replace(/-/g, " ")))
  })) : null, showDateFilter && from === "web" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "page-content-wrapper-menu-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilter, {
      onFilterChange: onFilterChange,
      startDate: startDate,
      endDate: endDate,
      filterData: filterData,
      onClose: hideOverlay,
      organisationBilling: organisationBilling,
      role: role,
      organisationSettings: organisationSettings,
      timezoneFilter: timezoneFilter,
      setTimezoneFilter: setTimezoneFilter,
      activeMenus: activeMenus
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "page-content-wrapper-menu-filter-date"
  }, /*#__PURE__*/React.createElement(MdDateRange, {
    className: "page-content-wrapper-menu-filter-date-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "page-content-wrapper-menu-filter-date-text"
  }, filterData))) : null, showTeamFilter && from === "web" || showTeamFilter && from !== "web" && !task ? /*#__PURE__*/React.createElement(Dropdown, {
    onSelect: function onSelect(evt) {
      var selectedTeamData = organisationTeams.find(function (team) {
        return team.teamId === evt;
      });
      setTeamName(evt === "all" ? "All Team" : selectedTeamData.teamName);
      setTeamId(evt);
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    from: from,
    as: CustomToggle
  }, value === null || value === void 0 ? void 0 : value.teamName), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "workfolio-header-page-content-wrapper-menu-filter-team-menu"
  }, organisationTeams.length > 1 && from === "web" ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    eventKey: "all"
  }, "All Team") : null, organisationTeams.map(function (item) {
    return item.roleName == "Admin" || item.roleName == "Head" || from == "web" && item.roleName == "Member" ? /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: item.teamId,
      eventKey: item.teamId
    }, item.teamName) : null;
  }))) : null, showTeamFilter && from !== "web" && task ? /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 0,
      fontWeight: 500,
      border: "1px solid #adadad",
      padding: "0px 10px",
      borderRadius: 60,
      fontSize: 15
    },
    title: "Clock out to switch your team"
  }, value === null || value === void 0 ? void 0 : value.teamName) : null, /*#__PURE__*/React.createElement(MenuFooter, {
    linkAttribute: linkAttribute,
    linkComponent: linkComponent,
    organisationDetails: organisationDetails,
    setTeamId: setTeamId,
    from: from,
    viewMode: viewMode,
    setViewMode: setViewMode,
    handleFullScreen: handleFullScreen,
    history: history
  }));
};
export var CustomToggle = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    _onClick = _ref2.onClick,
    from = _ref2.from;
  return /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-date",
    ref: ref,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick(e);
    }
  }, /*#__PURE__*/React.createElement(HiUserGroup, {
    className: "page-content-wrapper-menu-filter-user-group-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "page-content-wrapper-menu-filter-date-text ".concat(from === "desktop" ? "page-content-wrapper-menu-filter-date-text-desktop" : "")
  }, children), /*#__PURE__*/React.createElement(GoChevronDown, {
    className: "page-content-wrapper-menu-filter-dropdown-icon"
  }));
});
export default /*#__PURE__*/React.memo(Header);
function TimeFilter(props) {
  var _localStorage, _localStorage$getItem, _localStorage2, _localStorage2$getIte, _localStorage3, _localStorage3$getIte;
  var onFilterChange = props.onFilterChange,
    onClose = props.onClose,
    organisationBilling = props.organisationBilling,
    role = props.role,
    organisationSettings = props.organisationSettings,
    timezoneFilter = props.timezoneFilter,
    setTimezoneFilter = props.setTimezoneFilter,
    activeMenus = props.activeMenus;
  var _useState11 = useState({
      startDate: props.startDate,
      endDate: props.endDate
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    dates = _useState12[0],
    setDates = _useState12[1];
  var _useState13 = useState(props.filterData),
    _useState14 = _slicedToArray(_useState13, 2),
    filterData = _useState14[0],
    setFilterData = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    customMemberError = _useState16[0],
    setCustomMemberError = _useState16[1];
  // const [isToggled, setIsToggled] = useState(false);
  var _useState17 = useState(localStorage.getItem("timezone") == "organisationTimezone" ? true : false),
    _useState18 = _slicedToArray(_useState17, 2),
    isToggled = _useState18[0],
    setIsToggled = _useState18[1];
  useEffect(function () {
    setDates({
      startDate: props.startDate,
      endDate: props.endDate
    });
    setFilterData(props.filterData);
  }, [props.startDate, props.endDate]);
  var handleDateChange = function handleDateChange(date) {
    var _date = _slicedToArray(date, 2),
      startDate = _date[0],
      endDate = _date[1];
    setCustomMemberError(null);
    var diffInDays = 0;
    if (startDate && endDate) {
      var startDateMoment = moment(startDate);
      var endDateMoment = moment(endDate);
      diffInDays = endDateMoment.diff(startDateMoment, "days") + 1;
    }
    if (role != "Member" || role == "Member" && diffInDays <= 31) {
      if (diffInDays > 31) {
        setCustomMemberError("Maximum 31 days can be selected at once. Please select the remaining dates separately.");
      }
      setDates({
        startDate: startDate,
        endDate: endDate
      });
      setFilterData(arrayToStringOutput(date, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
    } else if (role == "Member" && diffInDays > 31) {
      setCustomMemberError("You can select a maximum of 31 days only.");
      setDates({
        startDate: startDate,
        endDate: endDate
      });
      setFilterData(arrayToStringOutput(date, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
    }
  };
  var handlePlanStatusDateChange = function handlePlanStatusDateChange(date) {
    setDates({
      startDate: date,
      endDate: null
    });
    setFilterData(arrayToStringOutput([date, null], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  };
  var handleFilterButtonClick = function handleFilterButtonClick(filter) {
    setFilterData(filter);
    var _stringToArrayOutput = stringToArrayOutput(filter, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone),
      _stringToArrayOutput2 = _slicedToArray(_stringToArrayOutput, 2),
      startDate = _stringToArrayOutput2[0],
      endDate = _stringToArrayOutput2[1];
    setDates({
      startDate: startDate,
      endDate: endDate
    });
  };
  var handleFilterChange = function handleFilterChange(dates) {
    return function () {
      onFilterChange(dates);
      onClose();
    };
  };
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var datePickerMinDate = stringToArrayOutput("Last 14 Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);

  // console.log({ check: !organisationSettings.enablePersonWiseTimezone || !localStorage?.getItem?.("timezone") });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay"
  }, !organisationSettings.enablePersonWiseTimezone || !((_localStorage = localStorage) !== null && _localStorage !== void 0 && (_localStorage$getItem = _localStorage.getItem) !== null && _localStorage$getItem !== void 0 && _localStorage$getItem.call(_localStorage, "timezone")) ? /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-date-wrapper"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: startDate,
    onChange: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" || role == "Member" && filterData == "Custom" || activeMenus.firstMenu == "timeline" ? handlePlanStatusDateChange : handleDateChange,
    startDate: startDate,
    endDate: endDate,
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? datePickerMinDate[0] : "",
    selectsRange: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" || role == "Member" && filterData == "Custom" || activeMenus.firstMenu == "timeline" ? false : true
  })), /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier"
  }, /*#__PURE__*/React.createElement("p", null, "Filter by Period"), /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier-listing"
  }, filterOptions.map(function (value) {
    return /*#__PURE__*/React.createElement(FilterButton, {
      key: value,
      onFilterButtonClick: handleFilterButtonClick,
      isSelected: value === filterData ? true : value === "Custom" && filterOptions.includes(filterData) === false ? true : false,
      value: value,
      planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
      planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
      role: role,
      activeMenus: activeMenus,
      setCustomMemberError: setCustomMemberError
    });
  }))))) : /*#__PURE__*/React.createElement("div", {
    className: classNames("page-content-wrapper-menu-filter-date-wrapper-filter-timezone", {
      "page-content-wrapper-menu-filter-date-wrapper-timezone-filter-custom": filterData == "Custom"
    })
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: classNames("page-content-wrapper-menu-filter-overlay-list", {
      "page-content-wrapper-menu-filter-overlay-list-timezone-filter": (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : (_localStorage2$getIte = _localStorage2.getItem) === null || _localStorage2$getIte === void 0 ? void 0 : _localStorage2$getIte.call(_localStorage2, "timezone")
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier"
  }, /*#__PURE__*/React.createElement("p", null, "Filter by Period"), /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier-listing"
  }, filterOptions.map(function (value) {
    return /*#__PURE__*/React.createElement(FilterButton, {
      key: value,
      onFilterButtonClick: handleFilterButtonClick,
      isSelected: value === filterData ? true : value === "Custom" && filterOptions.includes(filterData) === false ? true : false,
      value: value,
      planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
      planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
      role: role,
      activeMenus: activeMenus,
      setCustomMemberError: setCustomMemberError
    });
  })))), filterData == "Custom" ? /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-datepicker-filter-timezone"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: startDate,
    onChange: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" || role == "Member" && filterData == "Custom" ? handlePlanStatusDateChange : handleDateChange,
    startDate: startDate,
    endDate: endDate,
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? datePickerMinDate[0] : "",
    selectsRange: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" || role == "Member" && filterData == "Custom" ? false : true
  })) : null)), customMemberError ? /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-custom-member-filter-error-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-custom-member-filter-error"
  }, customMemberError), /*#__PURE__*/React.createElement("div", null)) : null, /*#__PURE__*/React.createElement("div", {
    className: classNames("page-content-wrapper-menu-filter-overlay-button", {
      "page-content-wrapper-menu-filter-overlay-button-timezone-filter": (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : (_localStorage3$getIte = _localStorage3.getItem) === null || _localStorage3$getIte === void 0 ? void 0 : _localStorage3$getIte.call(_localStorage3, "timezone")
    })
  }, /*#__PURE__*/React.createElement(Button, {
    className: "page-content-wrapper-menu-filter-overlay-button-cancel",
    variant: "outline-primary",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "page-content-wrapper-menu-filter-overlay-button-apply",
    onClick: customMemberError != null ? null : handleFilterChange(dates),
    disabled: customMemberError != null
  }, "Apply")));
}
function FilterButton(_ref3) {
  var value = _ref3.value,
    isSelected = _ref3.isSelected,
    onFilterButtonClick = _ref3.onFilterButtonClick,
    planName = _ref3.planName,
    planStatus = _ref3.planStatus,
    role = _ref3.role,
    activeMenus = _ref3.activeMenus,
    setCustomMemberError = _ref3.setCustomMemberError;
  var handleFilterButtonClick = function handleFilterButtonClick(value) {
    return function () {
      setCustomMemberError(null);
      onFilterButtonClick(value);
    };
  };

  // value == "Last 7 Days" ||

  return planName == "free" && (value == "Last Month" || value == "This Month" || value == "Custom") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade the plan to see your old data")
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier-listing-card filter-menu-disabled"
  }, value)) : planStatus === "stopped" && (value == "This Week" || value == "This Month" || value == "Last 7 Days" || value == "Last Week" || value == "Last Month" || value == "Custom") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade the plan to see your old data")
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier-listing-card filter-menu-disabled"
  }, value)) :
  // : role == "Member" &&
  //   //value == "This Week" ||
  //   // value == "This Month" ||
  //   //value == "Last Week" ||
  //   // value == "Last Month" ||
  //   value == "Custom" ? (
  //   <div></div>
  // )
  activeMenus.firstMenu == "timeline" && (value == "This Week" || value == "This Month" || value == "Last Week" || value == "Last Month" || value == "Last 7 Days") ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement("button", {
    className: classNames("page-content-wrapper-menu-filter-overlay-list-contanier-listing-card", {
      "filter-menu-active": isSelected,
      "filter-menu-disabled": planName == "free" && (value == "Last Month" || value == "Custom")
    }),
    onClick: handleFilterButtonClick(value)
  }, value);
}
export var findDemoOrLiveSite = function findDemoOrLiveSite() {
  var currentUrl = window.location.href;
  if (currentUrl.includes("demo")) {
    return "demo";
  } else {
    return "live";
  }
};
export var startOfDayCheck = function startOfDayCheck(currentTimezone, organisationTimezone) {
  var currentSystemOffset = moment.tz(currentTimezone).utcOffset();
  var organisationSystemOffset = organisationTimezone ? moment.tz(organisationTimezone).utcOffset() : 0;
  return currentSystemOffset < 0 && organisationSystemOffset > 0 || currentSystemOffset < 0 && organisationSystemOffset < 0 && currentSystemOffset == organisationSystemOffset || currentSystemOffset < 0 && organisationSystemOffset < 0 && currentSystemOffset < organisationSystemOffset ? true : false;
};
export var endOfDayCheck = function endOfDayCheck(currentTimezone, organisationTimezone) {
  var currentSystemOffset = moment.tz(currentTimezone).utcOffset();
  var organisationSystemOffset = organisationTimezone ? moment.tz(organisationTimezone).utcOffset() : 0;
  return currentSystemOffset > 0 && organisationSystemOffset < 0 || currentSystemOffset > 0 && organisationSystemOffset < 0 && currentSystemOffset - Math.abs(organisationSystemOffset) < 0 || currentSystemOffset > 0 && organisationSystemOffset > 0 && currentSystemOffset > organisationSystemOffset || currentSystemOffset < 0 && organisationSystemOffset < 0 && Math.abs(currentSystemOffset) < Math.abs(organisationSystemOffset);
};

// export const stringToArrayOutput = (stringData) => {
//   let arrayOfDates = [];

//   // THIS WEEK
//   const thisWeekStartOfDay = moment(moment().startOf("week")).add(1, "d");
//   const thisWeekEndOfDay = moment(thisWeekStartOfDay).add(6, "d");

//   // THIS MONTH
//   const thisMonthStartDate = moment().startOf("month").startOf("day");
//   const thisMonthEndDate = moment().endOf("month").startOf("day");
//   const thisMonthDiff = thisMonthEndDate.diff(thisMonthStartDate, "days");
//   const thisMonthEnd = moment(thisMonthStartDate).add(thisMonthDiff, "d");

//   // LAST WEEK
//   const lastWeekStartOfDay = moment(moment().startOf("week")).subtract(1, "weeks").add("d", 1);
//   const lastWeekEndOfDay = moment(lastWeekStartOfDay).add(6, "d");

//   // LAST MONTH
//   const lastMonthStartDay = moment(moment().subtract(1, "month")).startOf("month");
//   const lastMonthEndDay = moment(moment().subtract(1, "month")).endOf("month");
//   const lastMonthDiff = lastMonthEndDay.diff(lastMonthStartDay, "days");
//   const lastMonthEnd = moment(lastMonthStartDay).add(lastMonthDiff, "d");

//   // LAST 30 DAYS
//   const last30DaysStartDay = moment(moment().subtract(30, "days")).startOf("day");

//   switch (stringData) {
//     case "Today":
//       arrayOfDates = [moment().toDate(), null];
//       break;
//     case "Yesterday":
//       arrayOfDates = [moment().subtract(1, "day").toDate(), null];
//       break;
//     case "This Week":
//       arrayOfDates = [thisWeekStartOfDay.toDate(), thisWeekEndOfDay.toDate()];
//       break;
//     case "This Month":
//       arrayOfDates = [thisMonthStartDate.toDate(), thisMonthEnd.toDate()];
//       break;
//     case "Last Week":
//       arrayOfDates = [lastWeekStartOfDay.toDate(), lastWeekEndOfDay.toDate()];
//       break;
//     case "Last Month":
//       arrayOfDates = [lastMonthStartDay.toDate(), lastMonthEnd.toDate()];
//       break;
//     case "Last 7 Days":
//       arrayOfDates = [moment().subtract(7, "day").toDate(), moment().subtract(1, "day").toDate()];
//       break;
//     case "Last 30 Days":
//       arrayOfDates = [last30DaysStartDay.toDate(), moment().toDate()];
//       break;
//     case "Last 14 Days":
//       arrayOfDates = [moment().subtract(14, "day").toDate(), moment().subtract(1, "day").toDate()];
//       break;
//     case "Free Plan Days":
//       arrayOfDates = [moment().subtract(13, "day").toDate(), moment().toDate()];
//       break;
//     case "Custom":
//       break;

//     default:
//       break;
//   }

//   return arrayOfDates;
// };

export var stringToArrayOutput = function stringToArrayOutput(stringData, timezone) {
  var arrayOfDates = [];
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // TODAY
  var today = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("day").toDate() : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate();

  // YESTERDAY
  var yesterday = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("day").subtract(1, "day").toDate() : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("days").subtract(1, "day").toDate() : moment().tz(currentTimezone).clone().subtract(1, "day").toDate();

  // THIS WEEK
  var thisWeekStartOfDay = startOfDayCheck(currentTimezone, timezone) ? moment(moment().tz(currentTimezone).clone().startOf("week")).add(1, "d").startOf("day") : endOfDayCheck(currentTimezone, timezone) ? moment(moment().tz(currentTimezone).clone().startOf("week")).add(1, "d").endOf("day") : moment(moment().tz(currentTimezone).clone().startOf("week")).add(1, "d");
  var thisWeekEndOfDay = moment(thisWeekStartOfDay).add(6, "d");

  // THIS MONTH
  var thisMonthStartDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("month").startOf("day") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("month").endOf("day") : moment().tz(currentTimezone).clone().startOf("month");
  var thisMonthEndDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("month").startOf("day") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("month").endOf("day") : moment().tz(currentTimezone).clone().endOf("month");
  var thisMonthDiff = thisMonthEndDate.diff(thisMonthStartDate, "days");
  var thisMonthEnd = moment(thisMonthStartDate).add(thisMonthDiff, "d");

  // LAST WEEK
  var lastWeekStartOfDay = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("week").subtract(1, "weeks").add("d", 1).startOf("day") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("week").subtract(1, "weeks").add("d", 1).endOf("day") : moment().tz(currentTimezone).clone().startOf("week").subtract(1, "weeks").add("d", 1);
  var lastWeekEndOfDay = moment(lastWeekStartOfDay).add(6, "d");

  // LAST MONTH
  var lastMonthStartDay = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "month").startOf("month").startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "month").startOf("month").endOf("days") : moment().tz(currentTimezone).clone().subtract(1, "month").startOf("month");
  var lastMonthEndDay = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "month").endOf("month").startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "month").endOf("month").endOf("days") : moment().tz(currentTimezone).clone().subtract(1, "month").endOf("month");
  var lastMonthDiff = lastMonthEndDay.diff(lastMonthStartDay, "days");
  var lastMonthEnd = moment(lastMonthStartDay).add(lastMonthDiff, "d");

  // LAST 30 DAYS
  var last30DaysStartDay = moment(moment().subtract(30, "days")).startOf("day");

  // LAST 7 DAYS
  var last7DaysStartDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(7, "day").startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(7, "day").endOf("days") : moment().tz(currentTimezone).clone().subtract(7, "day");
  var last7DaysEndDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "day").startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "day").endOf("days") : moment().tz(currentTimezone).clone().subtract(1, "day");

  //LAST 14 DAYS
  var last14DaysStartDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(14, "day").startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(14, "day").endOf("days") : moment().tz(currentTimezone).clone().subtract(14, "day");
  var last14DaysEndDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().subtract(1, "day").startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("days").subtract(1, "day") : moment().tz(currentTimezone).clone().subtract(1, "day");

  //FREE PLAN DAYS

  var freePlanStartDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("days").subtract(13, "day") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("days").subtract(13, "day") : moment().tz(currentTimezone).clone().subtract(13, "day");
  var freePlanEndDate = startOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment().tz(currentTimezone).clone().endOf("days") : moment().tz(currentTimezone).clone();
  switch (stringData) {
    case "Today":
      arrayOfDates = [today, null];
      break;
    case "Yesterday":
      arrayOfDates = [yesterday, null];
      break;
    case "This Week":
      arrayOfDates = [thisWeekStartOfDay.toDate(), thisWeekEndOfDay.toDate()];
      break;
    case "This Month":
      arrayOfDates = [thisMonthStartDate.toDate(), thisMonthEnd.toDate()];
      break;
    case "Last Week":
      arrayOfDates = [lastWeekStartOfDay.toDate(), lastWeekEndOfDay.toDate()];
      break;
    case "Last Month":
      arrayOfDates = [lastMonthStartDay.toDate(), lastMonthEnd.toDate()];
      break;
    case "Last 7 Days":
      arrayOfDates = [last7DaysStartDate.toDate(), last7DaysEndDate.toDate()];
      break;
    case "Last 30 Days":
      arrayOfDates = [last30DaysStartDay.toDate(), moment().toDate()];
      break;
    case "Last 14 Days":
      arrayOfDates = [last14DaysStartDate.toDate(), last14DaysEndDate.toDate()];
      break;
    case "Free Plan Days":
      arrayOfDates = [freePlanStartDate.toDate(), freePlanEndDate.toDate()];
      break;
    case "Custom":
      break;
    default:
      break;
  }
  return arrayOfDates;
};
export var arrayToStringOutput = function arrayToStringOutput(arrayData, timezone) {
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // console.log({ currentSystemOffset, organisationSystemOffset });

  // currentSystemOffset > 0 &&
  //       organisationSystemOffset < 0 &&
  //       currentSystemOffset - Math.abs(organisationSystemOffset) < 0
  //     ? moment().tz(currentTimezone).clone().endOf("days").toDate()
  //     :

  var start = startOfDayCheck(currentTimezone, timezone) ? moment(arrayData[0]).startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment(arrayData[0]).endOf("days") : moment(arrayData[0]); //startOfDay(arrayData[0]);

  var date = moment();
  var end = arrayData[1] ? startOfDayCheck(currentTimezone, timezone) ? moment(arrayData[1]).startOf("days") : endOfDayCheck(currentTimezone, timezone) ? moment(arrayData[1]).endOf("days") : moment(arrayData[1]) : start;
  // endOfDay(arrayData[1]) : start;

  // if (
  //   isSameDay(startOfWeek(date, { weekStartsOn: 1 }), start) &&
  //   isSameDay(endOfWeek(date, { weekStartsOn: 1 }), end)
  // ) {
  //   return "This Week";
  // }

  // TODAY
  // let todayDate =
  //   currentSystemOffset < 0 && organisationSystemOffset > 0
  //     ? moment().tz(currentTimezone).clone().startOf("days")
  //     : moment().tz(currentTimezone).clone();

  var todayCheck = startOfDayCheck(currentTimezone, timezone) ? moment(start).isSame(moment().tz(currentTimezone).clone().startOf("days"), "day") && moment(end).isSame(moment().tz(currentTimezone).clone().startOf("days"), "day") : endOfDayCheck(currentTimezone, timezone) ? moment(start).isSame(moment().tz(currentTimezone).clone().endOf("days"), "day") && moment(end).isSame(moment().tz(currentTimezone).clone().endOf("days"), "day") : moment(start).isSame(moment().tz(currentTimezone).clone(), "day") && moment(end).isSame(moment().tz(currentTimezone).clone(), "day");
  var yesterdayCheck = startOfDayCheck(currentTimezone, timezone) ? moment(start).isSame(moment().tz(currentTimezone).clone().startOf("days").subtract(1, "day"), "day") && moment(end).isSame(moment().tz(currentTimezone).clone().startOf("days").subtract(1, "day"), "day") : endOfDayCheck(currentTimezone, timezone) ? moment(start).isSame(moment().tz(currentTimezone).clone().endOf("days").subtract(1, "day"), "day") && moment(end).isSame(moment().tz(currentTimezone).clone().endOf("days").subtract(1, "day"), "day") : moment(start).isSame(moment().tz(currentTimezone).clone().subtract(1, "day"), "day") && moment(end).isSame(moment().tz(currentTimezone).clone().subtract(1, "day"), "day");
  var last7DaysCheck = startOfDayCheck(currentTimezone, timezone) ? moment(end).isSame(moment().tz(currentTimezone).clone().subtract(1, "day").startOf("days"), "day") && end.diff(start, "days") === 6 : endOfDayCheck(currentTimezone, timezone) ? moment(end).isSame(moment().tz(currentTimezone).clone().subtract(1, "day").endOf("days"), "day") && end.diff(start, "days") === 6 : moment(end).isSame(moment().tz(currentTimezone).clone().subtract(1, "day"), "day") && end.diff(start, "days") === 6;
  var lastWeekCheck = startOfDayCheck(currentTimezone, timezone) ? moment(moment().tz(currentTimezone).clone().startOf("week").subtract(1, "weeks").add("d", 1).startOf("day")).isSame(start, "day") && moment(moment().tz(currentTimezone).clone().endOf("week").subtract(1, "weeks").add("d", 1).startOf("day")).isSame(end, "day") : endOfDayCheck(currentTimezone, timezone) ? moment(moment().tz(currentTimezone).clone().startOf("week").subtract(1, "weeks").add("d", 1).endOf("day")).isSame(start, "day") && moment(moment().tz(currentTimezone).clone().endOf("week").subtract(1, "weeks").add("d", 1).endOf("day")).isSame(end, "day") : moment(moment().tz(currentTimezone).clone().startOf("week").subtract(1, "weeks").add("d", 1)).isSame(start, "day") && moment(moment().tz(currentTimezone).clone().endOf("week").subtract(1, "weeks").add("d", 1)).isSame(end, "day");
  if (moment(moment(moment()).startOf("week").add("d", 1)).isSame(start, "day") && moment(moment(moment()).endOf("week").add("d", 1)).isSame(end, "day")) {
    return "This Week";
  }
  // if (
  //   isThisMonth(start) &&
  //   isThisMonth(end) &&
  //   isSameDay(startOfMonth(start), start) &&
  //   isSameDay(endOfMonth(end), end)
  // ) {
  //   return "This Month";
  // }
  else if (moment(start).isSame(moment(), "month") && moment(end).isSame(moment(), "month") && moment(moment(moment()).startOf("month")).isSame(start, "day") && moment(moment(moment()).endOf("month")).isSame(end, "day")) {
    return "This Month";
  }
  // if (isYesterday(end) && differenceInDays(end, start) === 6) {
  //   return "Last 7 Days";
  // }
  else if (last7DaysCheck) {
    return "Last 7 Days";
  }
  // if (isSameDay(subWeeks(startOfWeek(date, 1), 1), start) && isSameDay(subWeeks(endOfWeek(date, 1), 1), end)) {
  //   return "Last Week";
  // }
  else if (lastWeekCheck) {
    return "Last Week";
  }
  // if (isSameDay(subMonths(startOfMonth(date, 1), 1), start) && isSameDay(subMonths(endOfMonth(date, 1), 1), end)) {
  //   return "Last Month";
  // }
  else if (moment(moment(moment(moment()).subtract(1, "month")).startOf("month")).isSame(start, "day") && moment(moment(moment(moment()).subtract(1, "month")).endOf("month")).isSame(end, "day")) {
    return "Last Month";
  }

  // if (isToday(start)) {
  //   return "Today";
  // }
  else if (todayCheck) {
    return "Today";
  }

  // if (isYesterday(start)) {
  //   return "Yesterday";
  // }
  else if (yesterdayCheck) {
    return "Yesterday";
  }
  var startDay = moment(arrayData[0]).toDate();
  var endDay = moment(arrayData[1] ? arrayData[1] : arrayData[0]).toDate();
  return moment(start).isSame(end, "day") ? dateToYMD(startDay) : "".concat(dateToYMD(startDay), " - ").concat(dateToYMD(endDay));
};
function convertOrganisationTimezoneForTimesheet(sD, organisationTimezone) {
  var zoneoffset = moment(sD).tz(organisationTimezone).utcOffset();
  var startDate = moment(sD).tz(organisationTimezone);

  // console.log({ zoneoffset });
  // console.log({ utils: startDate });

  if (zoneoffset >= 0) {
    startDate = moment(startDate).add(zoneoffset, "minutes").toDate();
  } else {
    zoneoffset = Math.abs(zoneoffset);
    startDate = moment(startDate).add(zoneoffset, "minutes").toDate();
  }
  startDate = moment(startDate).format("YYYY-MM-DD");
  return startDate;
}
export var arrayToStringOutputForTimesheet = function arrayToStringOutputForTimesheet(arrayData, timezone) {
  var startDate = convertOrganisationTimezoneForTimesheet(arrayData[0], timezone);

  // console.log({ startDate });

  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var start = startDate;
  var end = startDate;

  // console.log({ current: moment().tz(currentTimezone).clone() });
  // console.log({
  //   start: moment(start).format("YYYY-MM-DD HH:mm:ss"),
  //   end: moment(end).format("YYYY-MM-DD HH:mm:ss"),
  //   currentFormat: moment().tz(currentTimezone).clone().format("YYYY-MM-DD HH:mm:ss"),
  // });
  // console.log({
  //   startCheck: moment(start).isSame(moment().tz(currentTimezone).clone(), "day"),
  //   endCheck: moment(end).isSame(moment().tz(currentTimezone).clone(), "day"),
  // });

  var todayCheck = start == moment().tz(currentTimezone).clone().format("YYYY-MM-DD") && end === moment().tz(currentTimezone).clone().format("YYYY-MM-DD");
  var yesterdayCheck = start == moment().tz(currentTimezone).clone().subtract(1, "day").format("YYYY-MM-DD") && end === moment().tz(currentTimezone).clone().subtract(1, "day").format("YYYY-MM-DD");
  if (todayCheck) {
    return "Today";
  } else if (yesterdayCheck) {
    return "Yesterday";
  }
  var startDay = moment(arrayData[0]).toDate();
  var endDay = moment(arrayData[1] ? arrayData[1] : arrayData[0]).toDate();
  return moment(start).isSame(end, "day") ? dateToYMD(startDay) : "".concat(dateToYMD(startDay), " - ").concat(dateToYMD(endDay));
};

// export const arrayToStringOutput = (arrayData) => {
//   const start = moment(arrayData[0]).startOf("day"); //startOfDay(arrayData[0]);

//   const date = moment();

//   const end = arrayData[1] ? moment(arrayData[1]).startOf("day") : moment(start).startOf("day");
//   // endOfDay(arrayData[1]) : start;

//   // if (
//   //   isSameDay(startOfWeek(date, { weekStartsOn: 1 }), start) &&
//   //   isSameDay(endOfWeek(date, { weekStartsOn: 1 }), end)
//   // ) {
//   //   return "This Week";
//   // }

//   if (
//     moment(moment(moment()).startOf("week").add("d", 1)).isSame(start, "day") &&
//     moment(moment(moment()).endOf("week").add("d", 1)).isSame(end, "day")
//   ) {
//     return "This Week";
//   }
//   // if (
//   //   isThisMonth(start) &&
//   //   isThisMonth(end) &&
//   //   isSameDay(startOfMonth(start), start) &&
//   //   isSameDay(endOfMonth(end), end)
//   // ) {
//   //   return "This Month";
//   // }
//   else if (
//     moment(start).isSame(moment(), "month") &&
//     moment(end).isSame(moment(), "month") &&
//     moment(moment(moment()).startOf("month")).isSame(start, "day") &&
//     moment(moment(moment()).endOf("month")).isSame(end, "day")
//   ) {
//     return "This Month";
//   }
//   // if (isYesterday(end) && differenceInDays(end, start) === 6) {
//   //   return "Last 7 Days";
//   // }
//   else if (moment(end).isSame(moment().subtract(1, "day"), "day") && end.diff(start, "days") === 6) {
//     return "Last 7 Days";
//   }
//   // if (isSameDay(subWeeks(startOfWeek(date, 1), 1), start) && isSameDay(subWeeks(endOfWeek(date, 1), 1), end)) {
//   //   return "Last Week";
//   // }
//   else if (
//     moment(moment(moment(moment()).startOf("week").add("d", 1)).subtract(1, "weeks")).isSame(start, "day") &&
//     moment(moment(moment(moment()).endOf("week").add("d", 1)).subtract(1, "weeks")).isSame(end, "day")
//   ) {
//     return "Last Week";
//   }
//   // if (isSameDay(subMonths(startOfMonth(date, 1), 1), start) && isSameDay(subMonths(endOfMonth(date, 1), 1), end)) {
//   //   return "Last Month";
//   // }
//   else if (
//     moment(moment(moment(moment()).subtract(1, "month")).startOf("month")).isSame(start, "day") &&
//     moment(moment(moment(moment()).subtract(1, "month")).endOf("month")).isSame(end, "day")
//   ) {
//     return "Last Month";
//   }

//   // if (isToday(start)) {
//   //   return "Today";
//   // }
//   else if (moment(start).isSame(moment(), "day") && moment(end).isSame(moment(), "day")) {
//     return "Today";
//   }

//   // if (isYesterday(start)) {
//   //   return "Yesterday";
//   // }
//   else if (
//     moment(start).isSame(moment().subtract(1, "day"), "day") &&
//     moment(end).isSame(moment().subtract(1, "day"), "day")
//   ) {
//     return "Yesterday";
//   }

//   const startDay = moment(arrayData[0]).toDate();
//   const endDay = moment(arrayData[1] ? arrayData[1] : arrayData[0]).toDate();

//   return moment(start).isSame(end, "day") ? dateToYMD(startDay) : `${dateToYMD(startDay)} - ${dateToYMD(endDay)}`;
// };

function dateToYMD(date) {
  var strArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var d = date.getDate();
  var m = strArray[date.getMonth()];
  var y = date.getFullYear();
  return "" + (d <= 9 ? "0" + d : d) + " " + m + ", " + y;
}